<template>
  <layout-quarter bg="/images/photo-7.jpg">
    <template v-slot:nav>
      <navigation :showBack="{ mobile: true, desktop: false }" :showLogout="true" />
    </template>

    <h1 class="heading h2 t-inverse t-center">Enquire about a property</h1>

    <enquire-form :properties="properties" />

    <a class="button button--link" @click="$router.back()">Cancel</a>
  </layout-quarter>
</template>

<style scoped lang="scss">
  .heading {
    margin-bottom: 100px;

    @include min-sm {
      margin-top: 90px;
      margin-bottom: 250px;
    }
  }
</style>

<script>
  import { mapState } from 'vuex';
  import LayoutQuarter from '@/layouts/Quarter';
  import Navigation from '@/components/Navigation';
  import EnquireForm from '@/components/EnquireForm';

  export default {
    name: 'Enquire',

    components: {
      LayoutQuarter,
      Navigation,
      EnquireForm
    },

    props: {
      id: {
        type: String,
        required: true
      }
    },

    data: () => ({
      properties: []
    }),

    computed: {
      ...mapState([
        'user',
      ]),

    },


    created () {
      if (this.id === 'all') {
        this.user.likedProperties.forEach(el => this.properties.push(el.property_id));
      } 
      else {
        this.properties.push(this.id);
      }
    }
  };
</script>